import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FeaturedSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-800">
              <i className="ri-information-line w-4 h-4 flex items-center justify-center text-sm" />
              {t("hero.eyebrow")}
            </p>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              {t("featured.title")}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              {t("featured.body")}
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/guide/usfans-spreadsheet-guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line w-4 h-4 flex items-center justify-center text-base" />
                {t("article.readMore")}
              </Link>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=An%20organized%20walk%20in%20closet%20with%20neatly%20folded%20sweaters%20on%20shelves%2C%20hanging%20shirts%20on%20a%20rail%20and%20a%20row%20of%20shoes%20below%2C%20soft%20warm%20natural%20light%2C%20clean%20minimal%20interior%20photography%2C%20fresh%20and%20tidy%20composition%20with%20warm%20neutral%20and%20sage%20green%20tones&width=1000&height=800&seq=featured-usfans-1&orientation=portrait&nocache=true"
              alt="USFans Spreadsheet explained"
              title="USFans Spreadsheet buying guide"
              className="h-72 w-full object-cover object-top md:h-96"
            />
          </div>
        </div>
      </div>
    </section>
  );
}